import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { getEnvironment } from '../../../shared/environment';
import { CommunitiesEnvironments } from '../../../shared/environment/models/communities-environments.enum';
import { ErrorConfig } from '../../models/error-config.model';
import { LoginSsoErrorTypes } from '../../models/login-sso-error-types.enum';
import { ssoErrorConfigs } from '../../utils/sso-error-config.utils';

@Component({
  selector: 'comm-sso-redirect-error',
  templateUrl: './sso-redirect-error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SsoRedirectErrorComponent {
  @Input() loading: boolean;

  @Output() readonly redirectToSso = new EventEmitter<void>();

  protected errorConfig: ErrorConfig;

  private currentErrorType: LoginSsoErrorTypes;

  private readonly supportLink =
    getEnvironment().env === CommunitiesEnvironments.BR_PROD
      ? 'https://api.whatsapp.com/send?phone=555130248787'
      : 'https://www.townsq.io/support';
  private readonly errorConfigs = ssoErrorConfigs;
  private readonly emitErrorTypes = [
    LoginSsoErrorTypes.AccessDenied,
    LoginSsoErrorTypes.OauthFailed,
  ];

  @Input() set ssoErrorType(value: LoginSsoErrorTypes) {
    this.errorConfig = this.errorConfigs[value];
    this.currentErrorType = value;
  }

  handleClick(): void {
    if (this.emitErrorTypes.includes(this.currentErrorType)) {
      this.redirectToSso.emit();
      return;
    }

    window.open(this.supportLink, '_self');
  }
}
